import * as React from "react";
import { Modal } from "@linkfluence/core/modal";
import { Project } from "@radarly/models/project";
import ModalContactManager from "./modal";

const MODAL_CONTACT = "modalContact";

type openFn = () => void;

interface IProps {
  project: Project;
  children: (open: openFn) => JSX.Element;
}

const Component = ({ children, project }: IProps) => {
  const { open, close, ModalWrapper } = Modal.get(MODAL_CONTACT);
  return (
    <>
      {children(open)}
      <ModalWrapper>
        <ModalContactManager close={() => close()} project={project} />
      </ModalWrapper>
    </>
  );
};

export default Component;
